import { render, staticRenderFns } from "./AddEDSStandard.vue?vue&type=template&id=4bf38bbc&"
import script from "./AddEDSStandard.vue?vue&type=script&lang=js&"
export * from "./AddEDSStandard.vue?vue&type=script&lang=js&"
import style0 from "./AddEDSStandard.vue?vue&type=style&index=0&id=4bf38bbc&prod&scopped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports